import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoVariationsGetRes } from "./abst/DtoVariationsGetRes";

export class DtoVariationsGetResImple extends DtoVariationsGetRes {
  public pager = new DtoApiPager();
}
